import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { Property } from '../../model/property';
import { CompanyService } from '../../service/data/company.service';
import { MessageService } from '../../../core/service/message.service';
import { CoreModule } from '../../../core/core.module';
import { PropertyService } from '../../service/data/property.service';
import { catchError, finalize, map, Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-move-property-to-company-dialog',
    templateUrl: './move-property-to-company-dialog.component.html',
    styleUrls: ['./move-property-to-company-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MovePropertyToCompanyDialogComponent implements OnInit, OnDestroy {
  constructor(
    private _dialogService: ActionWindowService,
    private _messageService: MessageService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory,
    private _dataService: PropertyService,
    companyService: CompanyService
  ) {
    this.companyService = companyService;
  }

  @Input() dataContext: Property;

  form: FormGroup;
  companyService: CompanyService;
  hasBankAccount: boolean;
  private _subscription = new Subscription();

  ngOnInit() {
    this.createForm();
    this.hasBankAccounts(this.form.value.destinationCompanyId);

    this._subscription.add(
      this.form.controls['destinationCompanyId'].valueChanges.subscribe(value => {
        this.hasBankAccounts(value);
      })
    );
  }

  private createForm() {
    this.form = this._fb.group({
      propertyId: this._fcf.createHidden(this.dataContext.id),
      destinationCompanyId: this._fcf.createMandatory('COMMON.COMPANY', null),
    });
  }

  private hasBankAccounts(destinationCompanyId: string) {
    if (!destinationCompanyId) {
      this.hasBankAccount = false;
      return;
    }

    this._subscription.add(
      this.companyService.get(destinationCompanyId).subscribe(data => {
        this.hasBankAccount = data.bankAccounts.some(() => true);
      })
    );
  }

  private _working = false;
  onSubmit() {
    if (this._working) return;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this._working = true;
    var formData = this.form.value;
    this._dataService
      .moveToCompany(formData.propertyId, formData.destinationCompanyId)
      .pipe(
        finalize(() => {
          this._working = false;
        }),
        catchError(err => {
          this._messageService.showError(err);
          this._dialogService.close();
          throw err;
        })
      )
      .subscribe(() => {
        this._messageService.showSuccess();
        this._dialogService.complete(true);
      });
  }
  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  cancel() {
    this._dialogService.close();
  }
}
